 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML01_HALFTITLE_PAGE from '@/components/html/01_Halftitle_Page'
 import HTML02_SERIES_PAGE from '@/components/html/02_Series_Page'
 import HTML03_TITLE_PAGE from '@/components/html/03_Title_Page'
 import HTML04_COPYRIGHT from '@/components/html/04_Copyright'
 import HTML05_DEDICATION from '@/components/html/05_Dedication'
 import HTML06_CONTENTS from '@/components/html/06_Contents'
 import HTML07_LIST_OF_FIGURES from '@/components/html/07_List_of_Figures'
 import HTML08_LIST_OF_ABBREVIATIONS from '@/components/html/08_List_of_Abbreviations'
 import HTML09_HALFTITLE_PAGE_1 from '@/components/html/09_Halftitle_Page_1'
 import HTML10_INTRODUCTION from '@/components/html/10_Introduction'
 import HTML11_1__LIFE_IN_THE_NORTH__BEFORE_THE from '@/components/html/11_1__Life_in_the_North__Before_the'
 import HTML12_2__A_GRAND_OPPORTUNITY__1861_AND from '@/components/html/12_2__A_Grand_Opportunity__1861_and'
 import HTML13_3__THE_FORMING_OF_BLACK_REGIMENT from '@/components/html/13_3__The_Forming_of_Black_Regiment'
 import HTML14_4__THE_UNEQUAL_PAY_ISSUE from '@/components/html/14_4__The_Unequal_Pay_Issue'
 import HTML15_5__VIOLENCE_ON_TWO_FRONTS from '@/components/html/15_5__Violence_on_Two_Fronts'
 import HTML16_6__INFORMATION_REQUESTS from '@/components/html/16_6__Information_Requests'
 import HTML17_7__DISCHARGE_REQUESTS from '@/components/html/17_7__Discharge_Requests'
 import HTML18_8__THE_CONCLUSION_OF_THE_WAR from '@/components/html/18_8__The_Conclusion_of_the_War'
 import HTML19_9__AFTER_THE_WAR__A_DIFFERENT_KI from '@/components/html/19_9__After_the_War__A_Different_Ki'
 import HTML20_10__EVEN_FARTHER_AWAY_FROM_HOME from '@/components/html/20_10__Even_Farther_Away_from_Home'
 import HTML21_11__HOME_AGAIN from '@/components/html/21_11__Home_Again'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML22_APPENDIX__NORTHERN_BLACK_REGIMEN from '@/components/html/22_Appendix__Northern_Black_Regimen'
 import HTML23_ACKNOWLEDGMENTS from '@/components/html/23_Acknowledgments'
 import HTML24_NOTES from '@/components/html/24_Notes'
 import HTML25_CITED_LITERATURE from '@/components/html/25_Cited_Literature'
 import HTML26_INDEX from '@/components/html/26_Index'
 import HTML27_SERIES_LIST from '@/components/html/27_Series_List'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_Contents",
 			"name" : "html/06_Contents",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_List_of_Figures",
 			"name" : "html/07_List_of_Figures",
 			"component" : HTML07_LIST_OF_FIGURES
 		},
 		{
 			"path" : "/html/08_List_of_Abbreviations",
 			"name" : "html/08_List_of_Abbreviations",
 			"component" : HTML08_LIST_OF_ABBREVIATIONS
 		},
 		{
 			"path" : "/html/09_Halftitle_Page_1",
 			"name" : "html/09_Halftitle_Page_1",
 			"component" : HTML09_HALFTITLE_PAGE_1
 		},
 		{
 			"path" : "/html/10_Introduction",
 			"name" : "html/10_Introduction",
 			"component" : HTML10_INTRODUCTION
 		},
 		{
 			"path" : "/html/11_1__Life_in_the_North__Before_the",
 			"name" : "html/11_1__Life_in_the_North__Before_the",
 			"component" : HTML11_1__LIFE_IN_THE_NORTH__BEFORE_THE
 		},
 		{
 			"path" : "/html/12_2__A_Grand_Opportunity__1861_and",
 			"name" : "html/12_2__A_Grand_Opportunity__1861_and",
 			"component" : HTML12_2__A_GRAND_OPPORTUNITY__1861_AND
 		},
 		{
 			"path" : "/html/13_3__The_Forming_of_Black_Regiment",
 			"name" : "html/13_3__The_Forming_of_Black_Regiment",
 			"component" : HTML13_3__THE_FORMING_OF_BLACK_REGIMENT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js